//File Generated by Castle.
//!IMPORTANT Manual Changes to this file will be overwritten
import AppRoutes from './AppRoutes';

export const navigationMap = {
  LookingToDoPage: {
    Primary: AppRoutes.BUY_FIRST_TIME_PAGE,
    Secondary: AppRoutes.BUILD_FIRST_TIME_PAGE,
    Tertiary: AppRoutes.REFINANCE_WHAT_NEXT_PAGE,

  },
  PreapprovedGetStartedPage: {
    Primary: AppRoutes.PREAPPROVED_FIRST_TIME_PAGE,

  },
  PreapprovedFirstTimePage: {
    Primary: AppRoutes.PREAPPROVAL_CONFIDENT_NOW_GOOD_TIME_PAGE,
    Secondary: AppRoutes.PREAPPROVAL_WHAT_TO_DO_WITH_CURRENT_HOME_PAGE,

  },
  PreapprovalApplyNowPage: {

  },
  PreapprovalConfidentNowGoodTimePage: {
    Primary: AppRoutes.PREAPPROVAL_IS_IT_RIGHT_TIME_PAGE,

  },
  PreapprovalIsItRightTimePage: {
    Primary: AppRoutes.PREAPPROVAL_EMOTIONALLY_READY_PAGE,

  },
  PreapprovalEmotionallyReadyPage: {
    Primary: AppRoutes.PREAPPROVAL_FINANCIALLY_READY_PAGE,

  },
  PreapprovalFinanciallyReadyPage: {
    Primary: AppRoutes.PREAPPROVAL_HOW_MUCH_SPEND_PAGE,

  },
  PreapprovalHowMuchSpendPage: {
    Primary: AppRoutes.PREAPPROVAL_WHAT_TO_DO_NEXT_PAGE,

  },
  PreapprovalWhatToDoNextPage: {
    Primary: AppRoutes.PREAPPROVAL_CHECKLIST_PAGE,

  },
  PreapprovalChecklistPage: {

  },
  PreapprovalWhatToDoWithCurrentHomePage: {
    Primary: AppRoutes.PREAPPROVAL_COULD_BE_FIRST_TIME_HOMEBUYER_PAGE,
    Secondary: AppRoutes.PREAPPROVAL_HOW_COORDINATE_BUY_SELL_PAGE,
    Tertiary: AppRoutes.PREAPPROVAL_WHAT_TO_DO_WITH_SECOND_HOME_PAGE,

  },
  PreapprovalCouldBeFirstTimeHomebuyerPage: {
    Primary: AppRoutes.PREAPPROVAL_IS_IT_RIGHT_TIME_PAGE,

  },
  PreapprovalHowCoordinateBuySellPage: {
    Primary: AppRoutes.PREAPPROVAL_WHAT_TO_DO_NEXT_PAGE,

  },
  PreapprovalWhatToDoWithSecondHomePage: {
    Primary: AppRoutes.PREAPPROVAL_PRICE_POINT_PAGE,
    Secondary: AppRoutes.PREAPPROVAL_IS_RENTAL_WORTH_IT_PAGE,

  },
  PreapprovalPricePointPage: {
    Primary: AppRoutes.PREAPPROVAL_CHECKLIST_PAGE,

  },
  PreapprovalIsRentalWorthItPage: {
    Primary: AppRoutes.PREAPPROVAL_CHECKLIST_PAGE,

  },
  BuyFirstTimePage: {
    Secondary: AppRoutes.BUY_SIGNED_CONTRACT_FIRST_TIME_HOMEBUYER_PAGE,
    Primary: AppRoutes.BUY_SIGNED_CONTRACT_NOT_FIRST_TIME_HOMEBUYER_PAGE,

  },
  BuySignedContractFirstTimeHomebuyerPage: {
    Primary: AppRoutes.BUY_HAVE_THIRTY_DAYS_PAGE,
    Secondary: AppRoutes.BUY_DO_YOU_HAVE_PREAPPROVAL_PAGE,

  },
  BuyHaveThirtyDaysPage: {
    Secondary: AppRoutes.BUY_PRE_APPROVAL_WITH_USWF_PAGE,
    Primary: AppRoutes.PURCHASE_IRQ_ADDRESS_PAGE,

  },
  BuyPreApprovalWithUswfPage: {
    Primary: AppRoutes.BUY_PRE_APPROVED_APPLY_NOW_PAGE,
    Secondary: AppRoutes.BUY_PRE_APPROVED_WITH_OTHER_PAGE,

  },
  BuyPreApprovedApplyNowPage: {

  },
  BuyPreApprovedWithOtherPage: {
    Primary: AppRoutes.LOOKING_TO_DO_PAGE,

  },
  BuyDoYouHavePreapprovalPage: {
    Primary: AppRoutes.BUY_DO_YOU_WANT_HYPOTHETICAL_QUOTE_PAGE,
    Secondary: AppRoutes.BUY_DO_YOU_WANT_TO_APPLY_PREAPPROVAL_FIRST_TIME_PAGE,

  },
  BuyDoYouWantHypotheticalQuotePage: {
    Secondary: AppRoutes.LOOKING_TO_DO_PAGE,
    Primary: AppRoutes.PURCHASE_IRQ_ADDRESS_PAGE,

  },
  BuyDoYouWantToApplyPreapprovalFirstTimePage: {
    Secondary: AppRoutes.PURCHASE_IRQ_ADDRESS_PAGE,

  },
  BuySignedContractNotFirstTimeHomebuyerPage: {
    Secondary: AppRoutes.BUY_DO_YOU_WANT_TO_APPLY_FOR_PREAPPROVAL_NOT_FIRST_TIME_PAGE,
    Primary: AppRoutes.BUY_DO_YOU_OWN_A_HOME_PAGE,

  },
  BuyDoYouWantToApplyForPreapprovalNotFirstTimePage: {
    Secondary: AppRoutes.BUY_DO_YOU_OWN_A_HOME_PAGE,

  },
  BuyDoYouOwnAHomePage: {
    Primary: AppRoutes.BUY_HOW_WILL_YOU_COORDINATE_PAGE,
    Secondary: AppRoutes.BUY_DO_YOU_WANT_TO_FAST_TRACK_PAGE,

  },
  BuyHowWillYouCoordinatePage: {
    Primary: AppRoutes.BUY_DO_YOU_WANT_TO_FAST_TRACK_PAGE,
    Secondary: AppRoutes.BUY_DO_YOU_WANT_TO_FAST_TRACK_PAGE,
    Tertiary: AppRoutes.BUY_DO_YOU_WANT_TO_FAST_TRACK_PAGE,
    Danger: AppRoutes.BUY_DO_YOU_WANT_TO_FAST_TRACK_PAGE,

  },
  BuyDoYouWantToFastTrackPage: {
    Secondary: AppRoutes.PURCHASE_IRQ_ADDRESS_PAGE,
    Primary: AppRoutes.PURCHASE_IRQ_COMPARE_PAGE,

  },
  BuildDoYouHavePlansPage: {
    Secondary: AppRoutes.BUILD_YOU_WILL_NEED_CONSTRUCTION_LOAN_PAGE,
    Primary: AppRoutes.BUILD_WHEN_DO_YOU_PLAN_TO_CLOSE_PAGE,

  },
  BuildYouWillNeedConstructionLoanPage: {
    Primary: AppRoutes.BUILD_IRQ_COMPARE_PAGE,

  },
  BuildYouNeedConstructionToPermanentLoanPage: {

  },
  BuildWhenDoYouPlanToClosePage: {
    Primary: AppRoutes.BUILD_LETS_BUILD_YOUR_QUOTE_PAGE,
    Secondary: AppRoutes.BUILD_WHAT_NEXT_PAGE,

  },
  BuildLetsBuildYourQuotePage: {
    Primary: AppRoutes.BUILD_IRQ_ADDRESS_PAGE,

  },
  BuildWithinNinetyDaysPage: {

  },
  BuildDosAndDontsPage: {

  },
  BuildLoanCommitmentPage: {

  },
  BuildWhatNextPage: {
    Primary: AppRoutes.BUILD_IRQ_ADDRESS_PAGE,

  },
  RefinancePrimaryReasonPage: {

  },
  RefinanceCashOutCalculatorPage: {

  },
  RefinanceShouldYouRefinancePage: {

  },
  RefinanceWhatNextPage: {
    Secondary: AppRoutes.REFINANCE_IRQ_ADDRESS_PAGE,
    Primary: AppRoutes.REFINANCE_IRQ_COMPARE_PAGE,

  },
  RefinanceIrqAddressPage: {
    Secondary: AppRoutes.REFINANCE_IRQ_NOT_SUPPORTED_PAGE,
    Primary: AppRoutes.REFINANCE_IRQ_PRIMARY_RESIDENCE_PAGE,
    Tertiary: AppRoutes.REFINANCE_IRQ_PROPERTY_NOT_SUPPORTED_PAGE,

  },
  RefinanceIrqNotSupportedPage: {
    Primary: AppRoutes.LOOKING_TO_DO_PAGE,

  },
  RefinanceIrqPrimaryResidencePage: {
    Primary: AppRoutes.REFINANCE_IRQ_PROPERTY_VALUE_PAGE,

  },
  RefinanceIrqPropertyTypePage: {

  },
  RefinanceIrqPropertyValuePage: {
    Primary: AppRoutes.REFINANCE_IRQ_EXISTING_BALANCE_PAGE,

  },
  RefinanceIrqExistingBalancePage: {
    Primary: AppRoutes.REFINANCE_IRQ_HOW_MUCH_CASH_OUT_PAGE,

  },
  RefinanceIrqTakeCashOutPage: {
    Primary: AppRoutes.REFINANCE_IRQ_PROPERTY_VALUE_PAGE,

  },
  RefinanceIrqHowMuchCashOutPage: {
    Primary: AppRoutes.REFINANCE_IRQ_CREDIT_SCORE_PAGE,

  },
  RefinanceIrqCreditScorePage: {
    Primary: AppRoutes.REFINANCE_IRQ_VETERAN_PAGE,
    Secondary: AppRoutes.REFINANCE_IRQ_US_CITIZEN_PAGE,

  },
  RefinanceIrqVeteranPage: {
    Secondary: AppRoutes.REFINANCE_IRQ_US_CITIZEN_PAGE,
    Primary: AppRoutes.REFINANCE_IRQ_DISABLED_VETERAN_PAGE,

  },
  RefinanceIrqSelfEmployedPage: {
    Primary: AppRoutes.REFINANCE_IRQ_WAIVE_ESCROW_PAGE,

  },
  RefinanceIrqClosingDatePage: {

  },
  RefinanceIrqWaiveEscrowPage: {
    Primary: AppRoutes.REFINANCE_IRQ_LOAN_OPTIONS_PAGE,

  },
  RefinanceIrqLoanOptionsPage: {
    Primary: AppRoutes.REFINANCE_IRQ_CONFIRMATION_PAGE,

  },
  RefinanceIrqConfirmationPage: {
    Primary: AppRoutes.REFINANCE_IRQ_COMPARE_PAGE,

  },
  RefinanceIrqComparePage: {

  },
  BuildIrqAddressPage: {
    Primary: AppRoutes.BUILD_IRQ_PRIMARY_RESIDENCE_PAGE,
    Secondary: AppRoutes.BUILD_IRQ_NOT_SUPPORTED_PAGE,
    Tertiary: AppRoutes.BUILD_IRQ_PROPERTY_NOT_SUPPORTED_PAGE,

  },
  BuildIrqNotSupportedPage: {
    Primary: AppRoutes.LOOKING_TO_DO_PAGE,

  },
  BuildIrqPrimaryResidencePage: {
    Primary: AppRoutes.BUILD_IRQ_PROPERTY_VALUE_PAGE,

  },
  BuildIrqPropertyTypePage: {

  },
  BuildIrqPropertyValuePage: {
    Primary: AppRoutes.BUILD_IRQ_DOWN_PAYMENT_PAGE,

  },
  BuildIrqDownPaymentPage: {
    Primary: AppRoutes.BUILD_IRQ_CREDIT_SCORE_PAGE,

  },
  BuildIrqCreditScorePage: {
    Primary: AppRoutes.BUILD_IRQ_VETERAN_PAGE,
    Secondary: AppRoutes.BUILD_IRQ_US_CITIZEN_PAGE,

  },
  BuildIrqVeteranPage: {
    Secondary: AppRoutes.BUILD_IRQ_US_CITIZEN_PAGE,
    Primary: AppRoutes.BUILD_IRQ_DISABLED_VETERAN_PAGE,

  },
  RefinanceIrqUsCitizenPage: {
    Primary: AppRoutes.REFINANCE_IRQ_SELF_EMPLOYED_PAGE,

  },
  BuildIrqUsCitizenPage: {
    Primary: AppRoutes.BUILD_IRQ_SELF_EMPLOYED_PAGE,

  },
  BuildIrqSelfEmployedPage: {
    Primary: AppRoutes.BUILD_IRQ_REAL_ESTATE_AGENT_PAGE,

  },
  BuildIrqRealEstateAgentPage: {
    Primary: AppRoutes.BUILD_IRQ_CLOSING_DATE_PAGE,

  },
  BuildIrqClosingDatePage: {
    Primary: AppRoutes.BUILD_IRQ_WAIVE_ESCROW_PAGE,

  },
  BuildIrqWaiveEscrowPage: {
    Primary: AppRoutes.BUILD_IRQ_LOAN_OPTIONS_PAGE,

  },
  BuildIrqLoanOptionsPage: {
    Primary: AppRoutes.BUILD_IRQ_CONFIRMATION_PAGE,

  },
  BuildIrqConfirmationPage: {
    Primary: AppRoutes.BUILD_IRQ_COMPARE_PAGE,

  },
  BuildIrqComparePage: {

  },
  PurchaseIrqAddressPage: {
    Secondary: AppRoutes.PURCHASE_IRQ_NOT_SUPPORTED_PAGE,
    Primary: AppRoutes.PURCHASE_IRQ_PRIMARY_RESIDENCE_PAGE,
    Tertiary: AppRoutes.PURCHASE_IRQ_PROPERTY_NOT_SUPPORTED_PAGE,

  },
  PurchaseIrqNotSupportedPage: {
    Primary: AppRoutes.LOOKING_TO_DO_PAGE,

  },
  PurchaseIrqPrimaryResidencePage: {
    Primary: AppRoutes.PURCHASE_IRQ_PROPERTY_VALUE_PAGE,

  },
  PurchaseIrqPropertyTypePage: {

  },
  PurchaseIrqPropertyValuePage: {
    Primary: AppRoutes.PURCHASE_IRQ_DOWN_PAYMENT_PAGE,

  },
  PurchaseIrqDownPaymentPage: {
    Primary: AppRoutes.PURCHASE_IRQ_CREDIT_SCORE_PAGE,

  },
  PurchaseIrqCreditScorePage: {
    Primary: AppRoutes.PURCHASE_IRQ_VETERAN_PAGE,
    Secondary: AppRoutes.PURCHASE_IRQ_US_CITIZEN_PAGE,

  },
  PurchaseIrqVeteranPage: {
    Secondary: AppRoutes.PURCHASE_IRQ_US_CITIZEN_PAGE,
    Primary: AppRoutes.PURCHASE_IRQ_DISABLED_VETERAN_PAGE,

  },
  PurchaseIrqUsCitizenPage: {
    Primary: AppRoutes.PURCHASE_IRQ_SELF_EMPLOYED_PAGE,

  },
  PurchaseIrqSelfEmployedPage: {
    Primary: AppRoutes.PURCHASE_IRQ_REAL_ESTATE_AGENT_PAGE,

  },
  PurchaseIrqRealEstateAgentPage: {
    Primary: AppRoutes.PURCHASE_IRQ_FOR_SALE_BY_OWNER_PAGE,

  },
  PurchaseIrqForSaleByOwnerPage: {
    Primary: AppRoutes.PURCHASE_IRQ_TITLE_COMPANY_PAGE,
    Secondary: AppRoutes.PURCHASE_IRQ_AS_IS_PAGE,

  },
  PurchaseIrqTitleCompanyPage: {
    Primary: AppRoutes.PURCHASE_IRQ_AS_IS_PAGE,

  },
  PurchaseIrqAsIsPage: {
    Primary: AppRoutes.PURCHASE_IRQ_CLOSING_DATE_PAGE,

  },
  PurchaseIrqClosingDatePage: {
    Primary: AppRoutes.PURCHASE_IRQ_WAIVE_ESCROW_PAGE,

  },
  PurchaseIrqWaiveEscrowPage: {
    Primary: AppRoutes.PURCHASE_IRQ_LOAN_OPTIONS_PAGE,

  },
  PurchaseIrqLoanOptionsPage: {
    Primary: AppRoutes.PURCHASE_IRQ_CONFIRMATION_PAGE,

  },
  PurchaseIrqConfirmationPage: {
    Primary: AppRoutes.PURCHASE_IRQ_COMPARE_PAGE,

  },
  PurchaseIrqComparePage: {

  },
  RefinanceIrqSeeVaLoanOptionsPage: {

  },
  RefinanceIrqDisabledVeteranPage: {
    Primary: AppRoutes.REFINANCE_IRQ_VA_LOAN_BEFORE_PAGE,

  },
  RefinanceIrqVaLoanBeforePage: {
    Primary: AppRoutes.REFINANCE_IRQ_US_CITIZEN_PAGE,

  },
  BuildIrqSeeVaLoanOptionsPage: {

  },
  BuildIrqDisabledVeteranPage: {
    Primary: AppRoutes.BUILD_IRQ_VA_LOAN_BEFORE_PAGE,

  },
  BuildIrqVaLoanBeforePage: {
    Primary: AppRoutes.BUILD_IRQ_US_CITIZEN_PAGE,

  },
  PurchaseIrqSeeVaLoanOptionsPage: {

  },
  PurchaseIrqDisabledVeteranPage: {
    Primary: AppRoutes.PURCHASE_IRQ_VA_LOAN_BEFORE_PAGE,

  },
  PurchaseIrqVaLoanBeforePage: {
    Primary: AppRoutes.PURCHASE_IRQ_US_CITIZEN_PAGE,

  },
  TestPagePage: {

  },
  BuildFirstTimePage: {
    Primary: AppRoutes.BUILD_DO_YOU_HAVE_PLANS_PAGE,
    Primary: AppRoutes.BUILD_DO_YOU_HAVE_PLANS_PAGE,
    Primary: AppRoutes.BUILD_DO_YOU_HAVE_PLANS_PAGE,
    Primary: AppRoutes.BUILD_DO_YOU_HAVE_PLANS_PAGE,

  },
  PurchaseIrqPropertyNotSupportedPage: {
    Primary: AppRoutes.LOOKING_TO_DO_PAGE,

  },
  BuildIrqPropertyNotSupportedPage: {
    Primary: AppRoutes.LOOKING_TO_DO_PAGE,

  },
  RefinanceIrqPropertyNotSupportedPage: {
    Primary: AppRoutes.LOOKING_TO_DO_PAGE,

  },

};
